;(function ($) {
  $(function () {
    $.addMatchHeight = function addMatchHeight (card) {
      if ($(window).width() < 768) {
        if (card.data('matchHeight') === 'true') {
          card.data('matchHeight', 'false')
          card.matchHeight({
            remove: true
          })
        }
      } else {
        if (
          card.data('matchHeight') === 'false' ||
          typeof card.data('matchHeight') === 'undefined'
        ) {
          card.data('matchHeight', 'true')
          card.matchHeight({
            byRow: true
          })
        }
      }
    }

    $.waitForElement = function waitForElement (querySelector, timeout) {
      return new Promise((resolve, reject) => {
        var timer = false
        if (document.querySelectorAll(querySelector).length) return resolve()
        const observer = new MutationObserver(() => {
          if (document.querySelectorAll(querySelector).length) {
            observer.disconnect()
            if (timer !== false) clearTimeout(timer)
            return resolve()
          }
        })
        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
        if (timeout)
          timer = setTimeout(() => {
            observer.disconnect()
            reject()
          }, timeout)
      })
    }

    /* Start limiting max characters of input */
    const inputWidthMaxLength = $('.js-limit-characters')

    function validateMaxCharacters (input) {
      var maxLength = input.data('max-length')
      var inputValue = input.val()

      if (inputValue.length > maxLength) {
        input.val(inputValue.slice(0, maxLength))
      }
    }

    inputWidthMaxLength.on('keyup', function () {
      validateMaxCharacters($(this))
    })
    /* End limiting max characters of input */

    /* Start remove error classes on input change */
    $(document).on('keydown', 'input, textarea', function () {
      $(this).closest('.js-input-group').removeClass('has-error')

      $(this).val() != ''
        ? $(this).addClass('has-value')
        : $(this).removeClass('has-value')
    })

    $(document).on('change', 'input[type="checkbox"]', function (e) {
      $(this).closest('.js-input-group').removeClass('has-error')
    })
    /* End remove error classes on input change */
  })
})(jQuery)
